import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { buildMoveOutModalRoute } from '@manager/modules/move-out/move-out-routes';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

import { facilityMapPermissions } from './facility-map-constants';

export const facilityMapRoutes: RouteMetaConfig[] = [
  {
    name: routeNames.facilityMapOverview,
    path: '/facility-map/:facilityMapId(\\d+)?',
    component: () => import('./views/FacilityMapListView.vue'),
    meta: {
      requiresAuth: true,
      permission: facilityMapPermissions.view,
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.facilityMapEditorCreateBooking,
          path: 'booking/create',
          component: () =>
            import('@manager/modules/booking/views/BookingCreateForm.vue'),
        },
        { fullscreen: true }
      ),
      buildModalRoute(
        {
          name: routeNames.facilityMapEditorAdjustBooking,
          path: 'booking/:bookingId(\\d+)/adjust',
          component: () =>
            import('@manager/modules/adjust-booking/views/BookingAdjustView.vue'),
        },
        { fullscreen: true }
      ),
      buildMoveOutModalRoute(
        routeNames.facilityMapMoveOut,
        'booking/:bookingId(\\d+)/move-out'
      ),
      buildModalRoute(
        {
          name: routeNames.facilityMapEditor,
          path: ':mapId/edit',
          meta: {
            requiresAuth: true,
            permission: facilityMapPermissions.create,
          },
          component: () => import('./views/FacilityMapEditorView.vue'),
        },
        { fullscreen: true }
      ),
    ],
  },
];

export const facilityMapRoutesFactory = {
  moveOut(bookingId: number, redirectTo: string) {
    return {
      name: routeNames.facilityMapMoveOut,
      params: {
        bookingId,
      },
      query: {
        redirectTo,
      },
    };
  },
  adjustBooking(bookingId: number, redirectTo: string, facilityMapId?: number) {
    return {
      name: routeNames.facilityMapEditorAdjustBooking,
      params: {
        facilityMapId,
        bookingId,
      },
      query: {
        redirectTo,
      },
    };
  },
};
